/** `YYYY-MM-DD` for a date in the viewer's local time zone (never UTC). */
export function localIsoDate(date: Date = new Date()): string {
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}

export function localIsoDateDaysAgo(days: number, from: Date = new Date()): string {
  const d = new Date(from)
  d.setDate(d.getDate() - days)
  return localIsoDate(d)
}

/** Keep `value` inside [min, max] (ISO date strings compare lexically). */
export function clampIsoDate(value: string, min?: string, max?: string): string {
  if (min && value < min) return min
  if (max && value > max) return max
  return value
}
